export const ssrApiPathMap = {
	tnas: 'tracking',
	learnEngine: 'learn-engine',
};
